import { render, staticRenderFns } from "./FeedbackAttempt.vue?vue&type=template&id=2bd501bc&scoped=true&"
import script from "./FeedbackAttempt.vue?vue&type=script&lang=js&"
export * from "./FeedbackAttempt.vue?vue&type=script&lang=js&"
import style0 from "./FeedbackAttempt.vue?vue&type=style&index=0&id=2bd501bc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bd501bc",
  null
  
)

component.options.__file = "FeedbackAttempt.vue"
export default component.exports